import {DocumentSummaryModel} from '../../../document/common/api/model/documentSummary.model';
import {BaseAuditableDto} from '../../../../shared/model/core/baseAuditableDto.model';
import {WithSummaryModel} from "../../../common/entity/dto/plain/withSummary.model";
import {MessageSummaryModel} from "./messageSummary.model";
import {BusinessContextSummaryModel} from "../../../common/businesscontext/api/entity/businessContextSummary.model";


export class MessageModel extends WithSummaryModel<MessageSummaryModel>{
    documents: DocumentSummaryModel[] = [];
    content: string;
    businessContext: BusinessContextSummaryModel;
}
